module.exports = __webpack_public_path__ + "img/va.e92b3489.svg";